import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OccEndpointsService } from "@spartacus/core";
import { Observable } from "rxjs";
import { ContentSearchData } from "./uig-content-search.models";

@Injectable()
export class UigContentSearchAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  contentSearch(
    search: string
  ): Observable<ContentSearchData> {
    const params = new HttpParams().set('search', search);
    return this.http.post<ContentSearchData>(
      this.occEndpoints.buildUrl('contentSearch'),
      {},
      { params }
    );
  }

}
